import axios from 'axios';

export default {
  async authenticate(query) {
    const response = await axios.create({ responseType: 'text', timeout: 30000, baseURL: '/esdemo' }).get(`/authenticate/${query}`);
    return response.data;
  },
  async searchDmo(search) {
    const response = await axios.create({ timeout: 30000, baseURL: '/esdemo' }).get(`/products/dmo/search/${encodeURI(search)}`);
    return response.data;
  },
  async searchPro(search) {
    const response = await axios.create({ timeout: 30000, baseURL: '/esdemo' }).get(`/products/pro/search/${encodeURI(search)}`);
    return response.data;
  },
}